import {createSlice} from '@reduxjs/toolkit';

const getInitialState = () => {
    return {
        uamTokenResponses: [],
    };
};

export const slice = createSlice({
    name: 'uam',
    initialState: getInitialState(),
    reducers: {
        addUamToken: (state, action) => {
            const newUamTokens = [...state.uamTokenResponses];

            newUamTokens.push(action.payload);

            return {
                ...state,
                uamTokenResponses: newUamTokens,
            };
        },
        clearUamTokenForCodentify: (state, action) => {
            const {codentify} = action.payload;
            const newUamTokens = state.uamTokenResponses.filter((x) => x.codentify !== codentify);

            return {
                ...state,
                uamTokenResponses: newUamTokens,
            };
        },
    },
});

export const {addUamToken, clearUamTokenForCodentify} = slice.actions;

export default slice.reducer;
